<template>
  <div
    class="te-title-flow-border"
    :style="{ borderColor: titleColor }"
  >
    <h3
      class="te-title-flow co-display-13 relative mb-0 inline-flex items-center py-1 pl-3 pr-6  font-bold leading-relaxed text-white md:pl-4"
      :style="{ backgroundColor: titleColor }"
    >
      <slot>
        太字タイトル
      </slot>
    </h3>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = withDefaults(defineProps<{
  titleColor?: string;
}>(), {
  titleColor: '#0B5770',
});

const titleColor = ref(props.titleColor);
</script>

<style scoped>
.te-title-flow-border {
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.te-title-flow {
  height: 1.875rem;
  &::after {
    position: absolute;
    right: -1px;
    content: '';
    border-right-style: solid;
    border-right-width: 1rem;
    border-bottom: solid 1.937rem transparent;
  }
}

/* // 奇数を白に */
.co-bg-striped:nth-child(odd) {
  .te-title-flow::after {
    border-right-color: #fff;
  }
}

/* // 偶数をグレーに */
.co-bg-striped:nth-child(even) {
  .te-title-flow::after {
    border-right-color: #f7f9f9;
  }
}
</style>
